import { useEffect, useMemo, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LangContext, translations } from "./i18n";
import { SmoothScroll } from "./components/SmoothScroll";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { EditorialMarquee } from "./components/Marquee";
import { About } from "./components/About";
import { Products } from "./components/Products";
import { Logistics } from "./components/Logistics";
import { WhyUs } from "./components/WhyUs";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import Admin from "./pages/Admin";
import ProductPage from "./pages/ProductPage";
import Legal from "./pages/Legal";

const ScrollToHash = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const timer = setTimeout(() => {
      document.getElementById(hash.replace("#", ""))?.scrollIntoView({ behavior: "smooth" });
    }, 500);
    return () => clearTimeout(timer);
  }, [pathname, hash]);
  return null;
};

const Landing = () => (
  <>
    <Header />
    <main>
      <Hero />
      <EditorialMarquee />
      <About />
      <Products />
      <Logistics />
      <WhyUs />
      <Testimonials />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  const [lang, setLang] = useState("fr");
  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang]);

  return (
    <LangContext.Provider value={value}>
      <SmoothScroll>
        <div className="App">
          <BrowserRouter>
            <ScrollToHash />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/produit/:key" element={<ProductPage />} />
              <Route path="/mentions-legales" element={<Legal kind="mentions" />} />
              <Route path="/politique-confidentialite" element={<Legal kind="privacy" />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors toastOptions={{ style: { borderRadius: 0 } }} />
        </div>
      </SmoothScroll>
    </LangContext.Provider>
  );
}

export default App;
